﻿window.info_measuringcomplexerror_edit = function () {
    var instance = {
        init: function () {

            im_decimal.mask(".decimalkvmask");
        }
    };
    var im_decimal = Inputmask("decimal", {
        inputtype: "text",
        radixPoint: ',',
        digits: 12,
        rightAlign: false,
        allowMinus: false
    });
    return instance;
}();

class info_measuringcomplexerror_edit_validate extends Tango.Component {
	widgetDidMount() {
        var _this = this;
        console.log("test");
		document.querySelectorAll("input[data-checkgroup1]").forEach(function (a) {
            var id = a.getAttribute('id');
            a.addEventListener("keyup", function () {
                _this.onKeyUpGroup1(id);
			});
        });

        document.querySelectorAll("input[data-checkgroup2]").forEach(function (a) {
            var id = a.getAttribute('id');
            a.addEventListener("keyup", function () {
                _this.onKeyUpGroup2(id);
            });
        });
        document.querySelector("input[name=ismcesetmanually]").addEventListener("change", function () {
            _this.onChangeManualEdit();
        });
    }

    onChangeManualEdit() {
        if (document.querySelector("input[name=ismcesetmanually]").checked == true) {
            document.querySelectorAll("input[data-checkgroup1]").forEach(function (a) {
                a.removeAttribute("style");
            });
            document.querySelectorAll("input[data-checkgroup2]").forEach(function (a) {
                a.removeAttribute("style");
            });

        }
        else {
            document.querySelectorAll("input[data-checkgroup1]").forEach(function (a) {
                if (a.value.length > 0)
                    a.removeAttribute("style");
                else
                    a.setAttribute("style", "border:2px solid #db7093");
            });

            var isNotempty
            document.querySelectorAll("input[data-checkgroup2]").forEach(function (a) {
                if (a.value.length > 0)
                    isNotempty = true;
            });

            if (isNotempty) {
                document.querySelectorAll("input[data-checkgroup2]").forEach(function (a) {
                    if (a.value.length > 0)
                        a.removeAttribute("style");
                    else
                        a.setAttribute("style", "border:2px solid #db7093");
                });
            }


        }
    }

    onKeyUpGroup1(id) {
        var key1 = "input[id=" + id + "]";
        var tb1 = document.querySelector(key1);
        if (tb1) {
            if (event.target.value.length == 0) {
                tb1.setAttribute("style", "border:2px solid #db7093");
            }
            else {
                tb1.removeAttribute("style");
            }
        }
    }

    onKeyUpGroup2(id) {
        var key1 = "input[id=" + id + "]";
        var isNotEmpty = false;
        document.querySelectorAll("[data-checkgroup2]").forEach(function (el) {
            if (el.value.length > 0)
                isNotEmpty = true;
        });
        if (isNotEmpty) {
            document.querySelectorAll("[data-checkgroup2]").forEach(function (el) {
                if (el.value.length == 0)
                    el.setAttribute("style", "border:2px solid #db7093");
                else
                    el.removeAttribute("style");
            });
        }
        else
        {
            document.querySelectorAll("[data-checkgroup2]").forEach(function (el) {
                el.removeAttribute("style");
            });
        }
    }

};

Tango.registerComponent(info_measuringcomplexerror_edit_validate, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));
